import { hasButtonPermission } from '@/utils/permission';

// 按钮权限指令
export const permission = {
  mounted(el, binding) {
    const { value } = binding;
    
    if (value) {
      const hasPermission = hasButtonPermission(value);
      
      if (!hasPermission) {
        // 如果没有权限，移除元素
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error('需要指定权限值');
    }
  }
};

export default permission; 